// Vendors
import { useEffect, useRef, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useIntl } from 'react-intl';
// Event Handlers
import { SessionExpireHandlers } from '../handlers/session-expire.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Hooks
import { useFeatureFlagsHook } from 'hooks/feature-flags.hook';
// Types
import { SessionExpireHookType } from './types/session-expire.hook.type';

const useSessionExpireHook = (): SessionExpireHookType => {
  const [sessionWarningMessage, setSessionWarningMessage] = useState('');

  const { formatMessage } = useIntl(),
    { showBoundary: setError } = useErrorBoundary();

  const { isUsableFeature } = useFeatureFlagsHook();

  const { handleSendCustomActionEvent } = LogHandlers(),
    { handleCloseWarningSnackbarEvent, handleInitSessionExpireObserveEvent } =
      SessionExpireHandlers({
        formatMessage,
        handleSendCustomActionEvent,
        isUsableFeature,
        setError,
        setSessionWarningMessage,
      });

  useEffect(() => {
    handleInitSessionExpireObserveEvent();
  }, []);

  return {
    handleCloseWarningSnackbarEvent,
    sessionWarningMessage,
  };
};

export { useSessionExpireHook };
